module.exports = __webpack_public_path__ + "static/about-mood-e9edfa7a205ac782e58e8d58b1f03d4d.jpg";